var map = {
	"./6_Filiere_bois_Tolkien.png": 34863,
	"./Filière_bois.png": 36664,
	"./Filière_végétale.png": 6514,
	"./Filière_végétale2.png": 37370,
	"./Kovanda_matière.png": 834,
	"./Mass_balance in_oil_mill.png": 73289,
	"./exemple_sankey_1.png": 46207,
	"./sankey_diagram_food_flow2.png": 4170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37957;